// extracted by mini-css-extract-plugin
export default {"root":"BtJrhC","ShinyMenuIButtonNSkin":"tpImQl","shinyMenuIButtonNSkin":"tpImQl","linkElement":"VFOEQr","shade":"CT4EmF","label":"t6GAPL"};